import {
    PARTNER_FAILED, PARTNER_LOADING, PARTNER_REMOVE, PARTNER_SUCCESS
} from "../types";

const initialState = {
    loading: false,
    error: null,
    status: null,
    partner: null,
    request: null,
};

export const partnerCrudReducer = (
    state = initialState,
    action: { type: any; loading: any; payload: any; status: any; error: any, request: any }
) => {
    switch (action.type) {
        case PARTNER_LOADING:
            return {
                ...state,
                loading: true,
            };
        case PARTNER_SUCCESS:
            return {
                ...state,
                loading: false,
                partner: action.payload,
                status: action.status,
                error: null,
                request: action.request
            };
        case PARTNER_FAILED:
            return {
                ...state,
                loading: false,
                status: action.status,
                error: action.error,
                request: action.request

            };
        case PARTNER_REMOVE:
            return initialState

        default:
            return state;
    }
};

